import React, { useState } from 'react';
import { useHubspotForm } from '@aaronhayes/react-use-hubspot-form';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getPortalId, getFormId, getHubCityLookupUrl } from '../../config/hubspotConfig';
import('./style.scss');

const FormInquiry = ({ fetchHubspotFormStatus, currentApplicant }) => {
  const [loading, setLoading] = useState(false);
  let isHubCity = false;
  let isMilitary = false;

  const { loaded, error, formCreated } = useHubspotForm({
    portalId: getPortalId(),
    formId: getFormId('inquiry'),
    target: '#course-application',
    onFormReady: function($form){
      if (currentApplicant) {
        let $theEmail = $form.find('input[name="email"]');
        $theEmail.val(currentApplicant.email).change();
      }

      let $postalCodeField = $form.find('input[name="zip"]');
      let $hubCityBoolean = $form.find('input[name="is_in_hubcity_at_time_of_latest_inquiry"]');
      let $hubCityField = $form.find('input[name="hub_city"]');

      let $militaryStatusField = $form.find('select[name="military_status_"]');

      $militaryStatusField.on("change input", function () {
        var militaryStatus = $(this).val();
        if (militaryStatus?.length > 0) {
          isMilitary = militaryStatus != "Non-military";
        }
      });

      $postalCodeField.on("input", function () {
        var zip = $(this).val();

        // Check if the input is a 5-digit zip code before making the API call
        if (zip.length >= 5) {
          async function getData() {
            const url = getHubCityLookupUrl() + "?zip=" + zip;
            try {
              const response = await fetch(url);
              if (!response.ok) {
                isHubCity = false;
                throw new Error(`Response status: ${response.status}`);
              }
              const json = await response.json();
              isHubCity = json.is_active;
              $hubCityBoolean.val(json.is_active ? "Yes" : "No");
              $hubCityField.val(
                json.hub_city ? json.hub_city : "Anywhere in the US",
              );
            } catch (error) {
              // Allow API errors to continue and Enrollment will need to disqualify users
              console.error(error.message);
              $hubCityBoolean.checked = false;
              $hubCityBoolean.val("No");
              $hubCityField.val("Anywhere in the US");
            }
          }

          getData();
        } else {
          isHubCity = false;
          $hubCityBoolean.checked = false;
          $hubCityBoolean.val("No");
          $hubCityField.val("Anywhere in the US");
        }
      });
    },
    onFormSubmitted: function () {
      setLoading(true);
      if (!isHubCity && !isMilitary) {
        window.location.href =
          "https://solutions.launchcode.org/application-not-for-hub-city";
      } else {
        if (fetchHubspotFormStatus) {
          fetchHubspotFormStatus();
        } else {
          window.location.href = '/learners/course_application';
        }
      }
    }
  });

  return (
    <>
      { currentApplicant && <h2>Begin Your Course Application</h2> }
      { !loading ? <div id='course-application'></div> : <ProgressSpinner /> }
    </>
  )
};

export default FormInquiry;
